/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import NumberedParagraph from "../NumberedParagraph/NumberedParagraph";
import { RS_ADDRESS, RS_ADDRESS_LOCALITY, RS_NAME, RS_POSTAL_CODE, SERVICE_EMAIL } from "../../services/globalVars";
import { Link } from "react-router-dom";

const TermsOfServiceExternalLawyers = () => {
  let number: number = 0;
  let subnumber: number = 0;

  function counter() {
    number++;
    return number;
  }

  function subcounter(number: number, reset = false) {
    subnumber = reset ? 1 : subnumber + 1;
    return number + "." + subnumber + "  ";
  }

  return (
    <Box id="abg">
      <Typography variant={"h2"} component={"h1"}>
        Nutzungsbedingungen
      </Typography>
      <Typography variant={"h2"}>für die Auftragsbearbeitung über Legalbird.io</Typography>
      <p>
        Die Website https://www.legalbird.io/ (<b>"Website"</b>) und die darüber verfügbaren Funktionen (
        <b>"Dienste"</b>) sind urheberrechtlich geschützt und gehören der {RS_NAME}, {RS_ADDRESS},{RS_POSTAL_CODE}{" "}
        {RS_ADDRESS_LOCALITY} (<b>"Legalbird"</b>, <b>"uns"</b> und <b>"wir"</b>). Legalbird bietet freiberuflich
        tätigen Anwälten (<b>"Nutzer"</b>, <b>"Auftragnehmer"</b> und <b>"Sie"</b>) die Möglichkeit, juristische
        Arbeiten (<b>"Aufträge"</b>) gegen eine Vergütung zu übernehmen.
      </p>
      <p>
        Aufträge können von Endverbrauchern, Kanzleien, Rechtsschutzversicherern (<b>"Auftraggebern"</b>) oder anderen
        Parteien auf der Website eingestellt werden.
      </p>
      <p>
        Diese Nutzungsbedingungen (<b>"Vereinbarung"</b>) legen die rechtlich verbindlichen Bedingungen für die
        Benutzung der Website und der Dienste durch Sie als Nutzer fest. Durch Ihre Registrierung für Dienste
        akzeptieren Sie diese Vereinbarung und sichern zu, dass Sie das Recht, die Befugnis und die Fähigkeit haben,
        diese Vereinbarung abzuschließen. Der Zugriff auf die Website bzw. die Dienste und ihre Benutzung ist Ihnen nur
        gestattet, wenn sie mindestens 18 Jahre alt sind. Falls Sie nicht mit allen Bestimmungen dieser Vereinbarung
        einverstanden sind, dürfen Sie die Dienste nicht nutzen.
      </p>
      <p>
        <b>
          Legalbird weist ausdrücklich darauf hin, selbst weder Betreiber einer Anwaltskanzlei zu sein noch anwaltliche
          oder sonstige rechtliche Beratung in eigenem Namen durchzuführen.
        </b>
      </p>
      <Typography variant={"h2"}>{counter()} Registrierung</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Die Aufträge und Dienste stehen Ihnen als Nutzer offen. Im Zusammenhang mit Ihrer Registrierung bei
            Legalbird schließen Sie einen Vertrag für die Nutzung der Legalbird Dienste und Annahme von Aufträgen (
            <b>"Rahmenvertrag"</b>), die für Sie mit dem von Ihnen gewähltem Benutzernamen und Passwort (
            <b>"Zugangsdaten"</b>) zugänglich sind.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Der Rahmenvertrag beginnt mit der Aktivierung der von Ihnen gewählten Zugangsdaten durch uns und ist auf
            unbestimmte Zeit abgeschlossen. Der Rahmenvertrag ist nicht übertragbar.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Bei Ihrer Registrierung sind Sie verpflichtet, richtige und vollständige Informationen insbesondere über
            Ihre Identität, Anschrift, Telefonnummer, E-Mail-Adresse, Qualifikationen (z.B. anwaltliche Zulassung bei
            der Bundesrechtsanwaltskammer) und – sofern für Abrechnungszwecke erforderlich – eine Bankverbindung zur
            Verfügung zu stellen. Wir können von Ihnen verlangen, dass Sie uns unverzüglich Unterlagen zum Nachweis der
            von Ihnen angegebenen Informationen vorlegen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Auch während der Laufzeit Ihres Vertrages müssen Sie die von Ihnen angegebenen Informationen und vorgelegten
            Unterlagen stets auf dem aktuellen Stand halten. Die notwendigen Änderungen können Sie über die von uns
            bereitgestellten Funktionen vornehmen.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Ihre Zugangsdaten</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Sie dürfen Ihre Zugangsdaten nicht an Dritte weitergeben. Die Weitergabe an Ihre Mitarbeiter zu dienstlichen
            Zwecken ist Ihnen gestattet. Stellen Sie dabei sicher, dass Ihre Mitarbeiter diese Nutzungsbedingungen
            beachten.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Zusammen mit Ihrem Benutzernamen wählen Sie bitte ein möglichst sicheres Passwort. Bitte ergreifen Sie die
            erforderlichen Maßnahmen, um Ihr Passwort gegen den unbefugten Gebrauch zu schützen. Verraten Sie bitte
            deshalb niemandem Ihr Passwort. Unsere Mitarbeiter werden Sie nicht nach Ihrem Passwort fragen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Bitte informieren Sie unseren Kundenservice unverzüglich, wenn Sie den Eindruck haben, dass Dritte Ihre
            Zugangsdaten unberechtigt nutzen. Bei begründetem Verdacht einer Fremdnutzung Ihrer Zugangsdaten dürfen wir
            die notwendigen Maßnahmen ergreifen und insbesondere den Zugang vorübergehend sperren oder schließen. Falls
            Dritte Ihre Zugangsdaten aufgrund Ihres Verschuldens unberechtigt nutzen, haben Sie die dadurch entstehenden
            Schäden zu ersetzen und etwa entstehende Nutzungsentgelte zu zahlen.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Information und Kommunikation</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Wir informieren Sie über für Sie relevante prozessuale oder technische Neuerungen im Zusammenhang mit der
            Nutzung unserer Dienste über unseren Slack Kanal oder per E-Mail. Ferner stehen wir Ihnen für Fragen gerne
            über unseren Slack Kanal zur Verfügung. Einen Zugang zu unserem Slack Kanal erhalten Sie auf Anfrage.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Sie erhalten von uns von Zeit zu Zeit wichtige Informationen zu Ihrem Vertrag. Diese Informationen
            übersenden wir in der Regel per E-Mail an die von Ihnen angegebene E-Mail-Adresse. Es ist deshalb wichtig,
            dass Sie Ihre E-Mail-Adresse stets aktuell halten und Ihr E-Mail-Konto regelmäßig auf den Eingang von
            Nachrichten überprüfen.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Nutzung</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Wir bemühen uns, Beschränkungen, Beeinträchtigungen, Verbindungsabbrüche oder andere Einschränkungen der
            Nutzung der Dienste, soweit dies technisch möglich ist, zu vermeiden. Bitte beachten Sie, dass wir bei dem
            gegenwärtigen Stand der Kommunikationstechnik derartige Einschränkungen nicht vollständig ausschließen
            können. Dies gilt für diejenigen Inhalte und Übertragungswege, die außerhalb unseres Einflussbereiches
            liegen. Für Einschränkungen, die wir zu vertreten haben, richtet sich unsere Haftung nach dem Abschnitt
            "Haftung" dieser Nutzungsbedingungen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Die Pflege und Weiterentwicklung unserer Dienste bedingen zeitweilige Nutzungseinschränkungen. Wir achten
            darauf, dass diese in einem für Sie zumutbaren Umfang bleiben.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Um unsere Systeme sowie Dritte vor schädlichen Programmen und Inhalten wie z. B. Viren, Trojanern oder
            Spam-E-Mails zu schützen, können wir technische Schutzmaßnahmen einsetzen. Dies beinhaltet unter anderem den
            Einsatz von Filtersystemen, soweit ein solcher insbesondere zum Schutz der Telekommunikations- und
            Datenverarbeitungssysteme angemessen ist.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Annahme von Aufträgen</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Auftraggeber stellen Ihre Aufträge auf der Website ein. Der vom Auftraggeber bei Legalbird veröffentlichte
            Auftrag stellt ein Angebot zur Übernahme des Auftrags und dessen Ausführung dar.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Bitte beachten Sie, dass die Vertragsbeziehung über die Ausführung des Auftrags ausschließlich zwischen dem
            Ihnen und dem Auftraggeber zustande kommt. Der Inhalt des Vertrages richtet sich nach Ihren Vereinbarungen
            und dem geltenden Vertragsrecht.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Die Aufträge enthalten eine kurze Auftragsbeschreibung mit den wesentlichen Hintergrundinformationen, den zu
            liefernden Arbeitsergebnissen (z.B. Dokumente, Legal Opinions, Berichte, etc.) (<b>"Briefing"</b>), ein
            Datum bis zu dem der Auftrag spätestens vom Auftragnehmer zu erledigen ist (<b>"Erledigungsfrist"</b>),
            sowie die Prüfkriterien, die der Auftraggeber für eine erfolgreiche Erledigung des Auftrags voraussetzt (
            <b>"Abnahmekriterien"</b>). Ferner enthält jeder Auftrag einen Vergütungsbetrag (exklusive MwSt.), der dem
            Auftragnehmer im Falle eines erfolgreich abgeschlossenen Auftrags zu entrichten ist (
            <b>"Vergütungsbetrag"</b>).
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Sobald Sie das Briefing, die Erledigungsfrist, die Abnahmekriterien und den Vergütungsbetrag zur Kenntnis
            genommen haben und den Auftrag annehmen möchten, erfolgt die Annahme des Auftrags durch Anhaken der Checkbox
            "Ich möchte diese Aufgabe verbindlich annehmen" und anschließendes Anklicken des Buttons "Aufgabe annehmen".
            (<b>"Auftragsannahme"</b>). Nach der Auftragsannahme wird die ausgeschriebene Aufgabe zur{" "}
            <b>"offenen Aufgabe"</b>.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Bearbeitung, Fristen & Abnahme von Aufträgen</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Sie verpflichten sich mit Auftragsannahme, den jeweiligen Auftrag bis zur Erledigungsfrist vollständig zu
            erledigen. Durch Anhaken der Checkbox "Ich möchten diese Aufgabe als erledigt markieren" und anschließendem
            Anklicken des Buttons "Aufgabe erledigt" markieren Sie die Aufgabe als erledigt (<b>"Erledigung"</b>) und
            die Aufgabe geht in den Status "erledigt" über (<b>"erledigte Aufgabe"</b>).
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Legalbird leitet die Information über die Erledigung an den Auftraggeber weiter. Dieser hat nun die
            Möglichkeit, die Aufgabe auf die Abnahmekriterien zu prüfen. Die Prüfung erfolgt zeitnah und in der Regel
            spätestens nach drei Werktagen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Wird die erledigte Aufgabe vom Auftraggeber als erfüllt befunden, so ist für den Auftragnehmer nichts mehr
            zu tun und die erledigte Aufgabe ist nach Abnahme durch den Auftraggeber unter <b>"abgenommene Aufgaben"</b>{" "}
            in der Aufgabenübersicht zu sehen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Wird die erledigte Aufgabe vom Auftraggeber als nicht erfüllt befunden, schreibt er dem Auftragnehmer
            Änderungswünsche oder Hinweise in die Aufgabe, die dem Auftragnehmer helfen, die Aufgabe zu erledigen. Diese
            Änderungswünsche können neben den definierten Abnahmekriterien auch weitere Sachverhalte wie z.B.
            inhaltliche Änderungen oder Änderungen der Form sein. In diesem Fall wird aus der erledigten Aufgabe wieder
            eine offene Aufgabe und der Auftragnehmer sollte die genannten Änderungswünsche schnellstmöglich umsetzen.
            Sobald er die Änderungswünsche umgesetzt hat, kann er die Aufgabe nochmals als erledigt markieren (s.
            "Erledigung").
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Abrechnung & Bezahlung</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Die Abrechnung der abgenommenen Aufgaben und noch nicht abgerechneten Aufgaben erfolgt in der Regel
            monatlich zum 10. des Folgemonats (<b>"Abrechnungsstichtag"</b>).
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Zum Abrechnungsstichtag erhalten Sie eine Aufstellung Ihrer abgerechneten Aufgaben als pdf-Datei in Ihrem
            persönlichen Bereich auf der Website zur Verfügung gestellt. Ferner erhalten Sie - ebenfalls als pdf-Datei -
            ein Gutschriftendokument über den Gesamtbetrag aller abgerechneten Aufgaben zzgl. der ausgewiesenen
            Mehrwertsteuer (<b>in Summe "Abrechnungsbetrag"</b>).
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Sofern Sie in Ihrem persönlichen Bereich Ihre Bankverbindung abgespeichert haben, erhalten Sie die Zahlung
            des Abrechnungsbetrages auf ebendiese. Es ist Ihre Pflicht, Ihre Bankverbindung stets aktuell zu halten.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Rechtmäßige Nutzung, Sperrung</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Sie dürfen unsere Dienste nur in einer Weise oder zu Zwecken nutzen, die nicht gegen diese
            Nutzungsbedingungen bzw. gegen geltendes Recht verstoßen oder Rechte Dritter verletzen. Bitte beachten Sie
            insbesondere: Die Verbreitung von rassistischen, pornografischen, gewaltverherrlichenden oder
            -verharmlosenden sowie sittenwidrigen Inhalten ist verboten. Ebenso untersagt ist die Verbreitung von
            Informationen, die Kinder oder Jugendliche in ihrer Entwicklung oder Erziehung beeinträchtigen oder
            gefährden oder die die Menschenwürde oder sonstige durch das Strafgesetzbuch geschützte Rechtsgüter
            verletzen. Ferner dürfen Sie nicht zu Straftaten aufrufen oder Anleitungen für Straftaten herstellen oder
            verbreiten. Die Beleidigung, Belästigung, Verleumdung oder Bedrohung anderer Nutzer ist verboten. Durch Ihre
            Nutzung dürfen Sie Urheber-, Marken- oder sonstige Schutzrechte Dritter nicht verletzen. Sie dürfen keine
            unaufgeforderten Massensendungen verbreiten.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Wir weisen auf die gesetzlichen Bestimmungen zur Bekämpfung von Schwarzarbeit und Scheinselbständigkeit hin.
            Die Durchführung von Aufträgen, die unter Verstoß gegen solche Bestimmungen oder andere gesetzliche
            Regelungen ausgeführt werden sollen, ist untersagt. Dies gilt auch für Vorbereitungshandlungen, die auf eine
            Ausführung eines Auftrags durch Schwarzarbeit zielen, um etwa den Auftrag außerhalb von Legalbird unter
            Verstoß gegen gesetzliche Bestimmungen zu erhalten.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Ferner weisen wir darauf hin, dass sowohl die Erbringung von als auch die Vergütung für Leistungen in
            bestimmten Bereichen durch gesetzliche Bestimmungen (z.B. durch das Rechtsanwaltsvergütungsgesetz)
            reglementiert und daher nicht oder nur eingeschränkt frei verhandelbar sind. Sie sind verpflichtet, die
            Einhaltung solcher Beschränkungen sicherzustellen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Wenn Sie diese Nutzungsbedingungen oder geltendes Recht schuldhaft verletzen, können wir die notwendigen
            Maßnahmen ergreifen. Diese können sich bei geringen Verstößen auf den Hinweis beschränken, dass die
            Nutzungsbedingungen, gesetzliche Bestimmungen oder die Pflicht zur Rücksichtnahme verletzt wurden. Schwere
            Verstöße können zur vorübergehenden oder völligen Sperrung einzelner Leistungen oder Ihres Zugangs oder
            sogar zur fristlosen Kündigung führen.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Bewertungen</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Bei den über Legalbird vergebenen Aufträgen hat der Auftraggeber die Möglichkeit Sie nach
            Auftragsdurchführung oder sonstiger Auftragsbeendigung zu bewerten (<b>"Bewertung"</b>).
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Durch die Bewertungen sollen andere Auftraggeber ein möglichst aussagekräftiges und zutreffendes Bild über
            Qualität, Zuverlässigkeit und Vertrauenswürdigkeit der Auftragnehmer erhalten. Um dieses Ziel zu erreichen,
            dürfen Auftraggeber ausschließlich sachliche und wahrheitsgemäße Aussagen über Auftragnehmer treffen.
            Insbesondere unzutreffende, unsachliche oder beleidigende Äußerungen sind zu unterlassen und können zur
            vollständigen oder teilweisen Löschung der Bewertung, zur Sperrung und/oder zu weitergehenden, angemessenen
            Maßnahmen führen.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Verwendung Ihrer personenbezogenen Daten</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Wir verwenden Ihre personenbezogenen Daten ausschließlich für die Bereitstellung, Nutzung und Abrechnung
            unserer Dienste, es sei denn, eine weitergehende Datenverwendung ist gesetzlich vorgesehen oder es liegt
            Ihre ausdrückliche Einwilligung vor.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Details zur Verarbeitung Ihrer personenbezogenen Daten finden Sie in einer gesonderten Datenschutzerklärung,
            die Sie <Link to={"/datenschutz"}>hier</Link> abrufen können.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Haftung</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Wir haften für jede schuldhafte Verletzung wesentlicher Vertragspflichten sowie bei Übernahme einer
            Beschaffenheitsgarantie nach den gesetzlichen Vorschriften. Für Schäden, die auf dem Fehlen einer
            vereinbarten Beschaffenheit beruhen, haften wir nur soweit diese von einer solchen Vereinbarung umfasst sein
            sollen. In allen anderen Fällen haften wir nur, soweit der entstandene Schaden grob fahrlässig oder
            vorsätzlich verursacht wurde.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Abweichend von Ziffer 11.1 gilt für Dienste, die wir unentgeltlich bereitstellen, ein Haftungsausschluss für
            Schäden, die wir leicht fahrlässig verursachen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Falls Sie eine unrichtige Bankverbindung angegeben haben und wir den Abrechnungsbetrag auf diese überweisen,
            haften wir nicht für die Rückabwicklung der Falschüberweisung oder einen Ersatz des Abrechnungsbetrages oder
            die Aufwände, die zur Rückabwicklung der Falschüberweisung entstehen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Die Schadensersatzpflicht für die Verletzungen von Leben, Körper oder Gesundheit sowie die Haftung nach dem
            Produkthaftungsgesetz bleibt durch die vorstehenden Regelungen in jedem Fall unberührt.
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Laufzeit & Beendigung des Vertrages</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Der Rahmenvertrag wird auf unbestimmte Zeit abgeschlossen. Der Rahmenvertrag ist unter Einhaltung einer
            Frist von einem Monat kündbar. Sofern Sie mit uns einen entgeltlichen Vertrag mit einer Mindestlaufzeit
            abgeschlossen haben, ist Ihre Kündigung innerhalb der genannten Frist frühestens zum Ablauf der
            Mindestlaufzeit möglich. Welche Mindestlaufzeit gilt, entnehmen Sie bitte der jeweiligen
            Leistungsbeschreibung.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>Für eine Kündigung ist Textform erforderlich. Senden Sie bitte eine E-Mail an {SERVICE_EMAIL}.</p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>Bitte beachten Sie, dass Sie nach Wirksamwerden der Kündigung unsere Dienste nicht mehr nutzen können.</p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Wir haben das Recht, einen mit Ihnen geschlossenen Vertrag fristlos zu kündigen, wenn uns ein Festhalten an
            dem Vertrag nicht mehr zuzumuten ist, insbesondere wenn Sie gegen diese Nutzungsbedingungen oder geltendes
            Recht schuldhaft verstoßen. Wir sind ferner berechtigt, Ihren Rahmenvertrag mit einer Frist von einem Monat
            ordentlich zu kündigen. Die Kündigung erfolgt durch E-Mail an die von Ihnen angegebene E-Mail-Adresse. Mit
            der wirksamen Kündigung des Rahmenvertrages aus wichtigem Grunde enden alle bestehenden vertraglichen
            Beziehungen über die Nutzung von Legalbird Diensten.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Im Falle einer Kündigung durch uns können Sie sich zu unseren Diensten nur mit unserem ausdrücklichen
            Einverständnis erneut anmelden. Legalbird Nutzern ist es nicht erlaubt, ehemaligen Legalbird Nutzern, denen
            wir gekündigt haben, die Nutzung unserer Dienste oder Produkte zu ermöglichen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={<p>Ihr Recht, den Vertrag aus wichtigem Grunde zu kündigen, bleibt unberührt.</p>}
      />
      <Typography variant={"h2"}>{counter()} Änderung der Nutzungsbedingungen & Leistungsänderungen</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Wir sind berechtigt, diese Nutzungsbedingungen im Laufe der Vertragslaufzeit anzupassen. Dies erfolgt, indem
            wir Ihnen die neuen Nutzungsbedingungen auf einem dauerhaften Datenträger (zum Beispiel durch Übersendung
            per E-Mail) zur Verfügung stellen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Die Änderung der Nutzungsbedingungen sind innerhalb der in unserer Mitteilung nach Ziffer 13.1 genannten
            Frist, frühestens aber nach Ablauf von 15 Tagen nach Eingang bei Ihnen gültig. Wir sind bemüht,
            schwerwiegendere Änderungen mit einer längeren Frist anzukündigen. Sie sind berechtigt, aufgrund der
            Änderungsankündigung innerhalb der Frist zu kündigen.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Die aktive Nutzung unserer Dienste vor Ablauf der Frist ist als eindeutige bestätigende Handlung zu
            betrachten, durch die auf die Frist verzichtet wird, außer in den Fällen, in denen die angemessene und
            verhältnismäßige Frist mehr als 15 Tage beträgt, weil Sie aufgrund der Änderungen der Nutzungsbedingungen
            erhebliche technische Anpassungen an Ihren Dienstleistungen vornehmen müssen. In diesen Fällen gilt das
            Einstellen neuer Dienstleistungen durch Sie nicht automatisch als Verzicht auf die Frist.
          </p>
        }
      />
      <NumberedParagraph
        paragraphNumber={subcounter(number, false)}
        paragraph={
          <p>
            Die Frist zum Inkrafttreten der angepassten Nutzungsbedingungen ist entbehrlich, wenn
            <br />
            a) wir aufgrund gesetzlicher oder behördlich angeordneter Verpflichtungen Änderungen der Nutzungsbedingungen
            in einer Art und Weise vornehmen müssen, die es uns nicht gestatten, die Frist von 15 Tagen nach Ziffer 13.2
            einzuhalten oder
            <br />
            b) wir in Ausnahmefällen unsere Nutzungsbedingungen zur Abwehr einer unvorhergesehenen und unmittelbar
            drohenden Gefahr ändern müssen, um die Online-Vermittlungsdienste, Verbraucher oder gewerbliche Nutzer vor
            Betrug, Schadsoftware, Spam, Verletzungen des Datenschutzes oder anderen Cybersicherheitsrisiken zu schützen
          </p>
        }
      />
      <Typography variant={"h2"}>{counter()} Gerichtsstand</Typography>
      <NumberedParagraph
        paragraphNumber={subcounter(number, true)}
        paragraph={
          <p>
            Sofern Sie ein in Deutschland ansässiger Anwalt sind, wird Köln als Gerichtsstand für alle Streitigkeiten im
            Zusammenhang mit der Nutzung von Legalbird vereinbart.
          </p>
        }
      />
      <p>Wir wünschen Ihnen viel Erfolg mit Legalbird!</p>
      <p>Stand: 01. August 2022</p>
    </Box>
  );
};

export default TermsOfServiceExternalLawyers;
